import React from 'react';
import ServiceGrid from '../components/ServiceGrid';

const Units: React.FC = () => {
  return (
    <div className="pt-20">
      <ServiceGrid />
    </div>
  );
};

export default Units;

